import { CheckDetailActions } from 'actions'
import { DetailsHeader, GetItFixedButton, UserFeedback, HelpEmail, Button, ChecksFeedback, Notice } from 'components'
import { SeoHelpers } from 'helpers'
import Tabs, { TabPane } from 'rc-tabs'
import TabContent from 'rc-tabs/lib/TabContent'
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar'
import FontIcon from 'material-ui/FontIcon'
import { Enum, AnalyticsUtils, CheckUtils } from 'utils'
import './tabs.css'
import './details.scss'

export default class Details extends React.Component {
  static contextTypes = {
    muiTheme: React.PropTypes.object.isRequired,
    currentUser: React.PropTypes.object,
  }

  static propTypes = {
    checkType:         React.PropTypes.object.isRequired,
    result:            React.PropTypes.object.isRequired,
    adhocUrl:          React.PropTypes.string,
    isEnjoying:        React.PropTypes.bool,
    willReview:        React.PropTypes.bool,
    willFeedback:      React.PropTypes.bool,
    feedbackDismissed: React.PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      activeTab: '0',
      shouldSelectTab: true,
    }
  }

  onTabChange(activeTab) {
    this.setState({ activeTab })
  }

  componentWillMount() {
    if (this.props.result.get('executeResult') === 'Exception') {
      AnalyticsUtils.errorViewed(this.context.currentUser.email, this.props.result.get('exception'))
    }
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.adhocUrl ^ nextProps.adhocUrl) || (this.props.adhocUrl !== nextProps.adhocUrl)) {
      this.setState({ activeTab: '0' })
    }
  }

  exceptionTitle(exception) {
    if (exception.match(/Invalid URI$/)) {
      return "Website URL Invalid"
    } else {
      return "Could not connect to your website"
    }
  }

  exceptionBody(exception) {
    if (exception.match(/Invalid URI$/)) {
      return <div>Please contact <HelpEmail /> and include the website URL.</div>
    } else {
      return (
        <div>
          Please refresh and try again. If the problem persists, please contact <HelpEmail />.
          <div className="medium-spacing--top">
            <Button
              label="Refresh and try again"
              buttonType="primary"
              onTouchTap={() => { window.location.reload() }}
            />
          </div>
        </div>
      )
    }
  }

  renderException(exception) {
    return (
      <div className="details__content">
        <div className="details__content__sheet-container">
          <div className="details__content__sheet">
            <div>
              <Notice error className="details__content__notice" header={ this.exceptionTitle(exception) }>
                { this.exceptionBody(exception) }
              </Notice>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    let result = this.props.result

    if (result.isEmpty()) {
      return (
        <div>
          <DetailsHeader checkType={this.props.checkType} result={result} adhocUrl={null} />
        </div>
      )
    }

    if (result.get('executeResult') == 'Exception') return this.renderException(result.get('exception'))

    let severityColor = SeoHelpers.severityColor(this.props.result.get('verdict'), this.context.muiTheme)
    let palette = this.context.muiTheme.palette

    let success = false
    if (result.get('executeResult')) {
      success = result.get('executeResult').toLowerCase() === 'success'
    }
    let checkTabs = null
    if (success === true) {
      let initialIndexSet = false
      checkTabs = result
        .get('checks')
        .map((check, index) => {
          if(!check.get('hidden')) {
            // initialIndexSet is quickfix for DEV-3833
            if (!initialIndexSet && this.state.shouldSelectTab) {
              initialIndexSet = true
              setTimeout(() => {
                this.setState({activeTab: '' + index, shouldSelectTab: false})
              }, 2000)
            }
            if (check.get("version") && check.get("version") == "V3") {
              return this.renderCheckV3(check, index, severityColor)
            } else {
              return this.renderCheck(check, index, severityColor)
            }
          } else if (check.get('title') == 'Page Type') {
            // else if page type then store page type result in localStorage
            check.get('checkItems').map(item => {
              localStorage.setItem('pageType', item.get('detailsKey'))
            })

          }
        }).toJS() // warning: without .toJS it works in Chrome but no other browsers
    }

    return (
      <div>
        <DetailsHeader checkType={this.props.checkType} result={result} adhocUrl={this.props.adhocUrl} />
        { ::this.renderExecuteResult(result.get('executeResult')) }
        { ::this.renderRuntimeError(result.get('responseStatus')) }
        <div>
          { success === true &&
            <Tabs
              renderTabBar={() => <ScrollableInkTabBar style={{ background: palette.accent2Color, color: palette.foregroundWhite }}/>}
              renderTabContent={() => <TabContent/>}
              activeKey={this.state.activeTab}
              onChange={::this.onTabChange}
            >
              { checkTabs }
            </Tabs>
          }
        </div>
      </div>
    )
  }

  renderExecuteResult(result) {
    if (result === undefined) return null

    result = result[0].toLowerCase() + result.slice(1)
    if (result === 'success') return null
    if (result === 'passwordProtected') return this.renderPasswordProtectedError()

    let solution = (
      <div className="medium-spacing2--top">
        Check your set up by pushing <FontIcon className="material-icons in-text-icon" style={{fontSize: 20}}>settings</FontIcon> above. If the problem persists please email <HelpEmail />.
      </div>
    )

    if (result === 'informationRequired') {
      solution = (
        <span>
          Please provide some information for the {this.props.checkType.name} check.
          <div className="medium-spacing--top">
            <Button
              label='Set up check'
              buttonType="primary"
              labelPosition="before"
              icon={<FontIcon className="material-icons in-text-icon">settings</FontIcon>}
              href={`/checks/setup/${this.props.checkType.key}`}
            />
          </div>
        </span>
      )
    } else if (result === 'upgradeRequired') {
      solution = (
        <span>
          <span>Upgrade to Plug in SEO Plus to check and optimize your Keywords</span>
          <div className="medium-spacing--top">
            <Button
              label='Find out more about Plug in SEO Plus'
              buttonType="primary"
              href='/plus/upgrade'
            />
            <Button
              label='No thanks'
              buttonType="secondary"
              href='/checks'
              className="secondary-btn"
            />
          </div>
        </span>
      )
    }

    return (
      <div className="details__content">
        <div className="details__content__sheet-container">
          <div className="details__content__sheet">
            <div className="flex-center--horizontal">
              <FontIcon className="material-icons small-spacing--right" style={{fontSize: 28}}>error_outline</FontIcon>
              <h3>Error</h3>
            </div>
            <p className="medium-spacing--top">{Enum.ExecuteResult[result]} {solution}</p>
          </div>
        </div>
      </div>
    )
  }

  renderPasswordProtectedError() {
    const shopPreferenceLink = `https://${this.context.currentUser.shop}/admin/online_store/preferences?tutorial=unlock`

    return (
      <div className="details__content">
        <div className="details__content__sheet-container">
          <Notice
            alert
            header="Your Shop is Password Protected"
            className="details__content__notice"
          >
            <p>We have detected that your shop is password protected.</p>
            <p className="medium-spacing2--top">Because Plug in SEO views your shop just like a search engine does, this also means that we can't check a password protected store.</p>
            <p className="large-spacing2--top">How to view your check:</p>
            <ol>
              <li className="small-spacing--top">Temporarily remove the storefront password in your <a href={shopPreferenceLink} target="_blank">Shopify Admin</a></li>
              <li className="small-spacing--top">Run the Plug in SEO check you're interested in, pushing the refresh icon to make sure to fetch the latest version</li>
              <li className="small-spacing--top">Fix any issues flagged by Plug in SEO</li>
              <li className="small-spacing--top">Re-add the storefront password</li>
            </ol>
            <p className="large-spacing2--top">If you have any questions email us at <HelpEmail />. We'd be happy to help you out.</p>
          </Notice>
        </div>
      </div>
    )
  }

  renderRuntimeError(error) {
    if (error && error.get('errorCode'))
      return (
        <div className="details__content">
          <div className="details__content__sheet-container">
            <div className="details__content__sheet">
              <div className="flex-center--horizontal">
                <FontIcon className="material-icons small-spacing--right" style={{fontSize: 28}}>info_outline</FontIcon>
                <h3>Error</h3>
              </div>
              <p className="medium-spacing--top">An unexpected error occurred. Email <HelpEmail /> with details.</p>
            </div>
          </div>
        </div>
      )
  }

  renderChecksSupportForm() {
    if (!['seoproblems', 'blog'].includes(this.props.checkType.key)) return null

    const surveyLink = this.props.checkType.surveyLinks[this.context.currentUser.activeCharge ? 'plus' : 'free']

    return (
      <ChecksFeedback
        href={surveyLink}
        featureType={this.props.checkType.key}
      />
    )
  }

  renderCheckV3(item, index, severityColor) {
    let palette = this.context.muiTheme.palette

    let color = index == this.state.activeTab ? palette.foregroundWhite : palette.foregroundWhiteFaded // we're comparing a string to a number so == is correct here

    let icon = SeoHelpers.severityIcon(item.get('severity'))
    let title = item.get("title")


    let tab = (
      <div style={{ color: color }}>
       { icon }
        <div>
          { CheckUtils.friendlyTitle(title) }
        </div>
      </div>
    )

    const componentProps = {
      check: item.toJS(),
      advisor: this.props.checkType,
      result: this.props.result,
      isEnjoying: this.props.isEnjoying,
      willReview: this.props.willReview,
      willFeedback: this.props.willFeedback,
      feedbackDismissed: this.props.feedbackDismissed
    }
    return (
      <TabPane
        tab={tab}
        key={index}
        className="details__content">
        <div className="details__content__sheet-container">
          <div className="details__content__sheet">
            { CheckUtils.renderV3Check(item, componentProps) }
          </div>
        </div>
      </TabPane>
    )

  }

  renderCheck(item, index, severityColor) {
    let palette = this.context.muiTheme.palette

    let color = index == this.state.activeTab ? palette.foregroundWhite : palette.foregroundWhiteFaded // we're comparing a string to a number so == is correct here

    let icon = SeoHelpers.severityIcon(item.get('severity'))

    let tab = (
      <div style={{ color: color }}>
       { icon }
        <div>
          { item.get('title') }
        </div>
      </div>
    )

    let checkItemDetails = item.get('checkItems').map((x, i) => {
      return <li key={i} dangerouslySetInnerHTML={{__html: x.get('details')}}></li>
    }).toJS() // warning: without .toJS it works in Chrome but no other browsers

    let severityText = 'What\'s wrong'
    let severitySubtext = null
    if (item.get('severity') === 'Pass') {
      severityText = 'You\'ve passed this check'
      severitySubtext = (
        <p>Your advisor hasn&apos;t found any action points for you on this check. But read below to learn best practice.</p>
      )
    }

    return (
      <TabPane
        tab={tab}
        key={index}
        className="details__content">
        <div className="details__content__sheet-container">
          <div className="details__content__sheet">
            <h2 className="details__content__header">How to Fix Your {item.get("title")}</h2>
            <div className="details__content__checks">
              <h3>{severityText}</h3>
              {severitySubtext}
              <ul>
                {checkItemDetails}
              </ul>
              <UserFeedback
                feedbackDismissed={this.props.feedbackDismissed}
                isEnjoying={this.props.isEnjoying}
                willReview={this.props.willReview}
                willFeedback={this.props.willFeedback} />
              <hr/>
              <div dangerouslySetInnerHTML={{__html: item.get('advice')}} />
              <div dangerouslySetInnerHTML={{__html: item.get('fixSteps')}} />
            </div>
            {this.renderChecksSupportForm()}
            <div className="xlarge-spacing2--top">
              <GetItFixedButton
                checkType={this.props.checkType}
                result={this.props.result}
                pageLocation="bottom"
              />
            </div>
          </div>
        </div>
      </TabPane>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/checks/Details.js